import { render, staticRenderFns } from "./SharedItemsBrowser.vue?vue&type=template&id=240eaafb&scoped=true"
import script from "./SharedItemsBrowser.vue?vue&type=script&lang=js"
export * from "./SharedItemsBrowser.vue?vue&type=script&lang=js"
import style0 from "./SharedItemsBrowser.vue?vue&type=style&index=0&id=240eaafb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240eaafb",
  null
  
)

export default component.exports